import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "placeholder", "disabled"]

import { ref, watch, onMounted } from "vue"
import { onClickOutside } from "@vueuse/core"
import screenType from "@/vue/planning/computed/screenType"

interface Props {
  label: string
  value: string
  dropdownOpen: boolean
  placeholder?: string
  disabled?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'dropdownInput',
  props: {
    label: {},
    value: {},
    dropdownOpen: { type: Boolean },
    placeholder: {},
    disabled: { type: Boolean }
  },
  emits: ["close", "open", "search"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const dropdown = ref<HTMLDivElement | null>(null)
const inputRef = ref<HTMLInputElement | null>(null)
const searchTerm = ref(props.value)

// Sync input when value prop changes externally
watch(() => props.value, (newVal) => {
  searchTerm.value = newVal
})

// Debounced input handler
let debounceTimeout: ReturnType<typeof setTimeout> | null = null
function handleInput(event: Event) {
  const val = (event.target as HTMLInputElement).value
  searchTerm.value = val

  if (debounceTimeout) clearTimeout(debounceTimeout)

  if (val.length === 0) {
    emit("search", "")
    return
  }

  debounceTimeout = setTimeout(() => {
      emit("search", val)
  }, 300)
}

// Handle dropdown open state on mobile
watch(
  () => props.dropdownOpen,
  (newValue) => {
    if (screenType.value !== "mobile") return
    if (newValue) {
      document.body.classList.add("overflow-hidden")
    } else {
      document.body.classList.remove("overflow-hidden")
    }
  }
)

onMounted(() => {
  onClickOutside(dropdown, () => {
    if (props.dropdownOpen) {
      emit("close")
    }
  })
})

__expose({
  inputRef
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdown",
    ref: dropdown,
    class: "dropdown-container position-relative"
  }, [
    _createElementVNode("input", {
      value: searchTerm.value,
      type: "text",
      ref_key: "inputRef",
      ref: inputRef,
      class: _normalizeClass(["dropdown-input dropdown border-default bg-primary-white w-100 outline-none d-flex align-items-center dropdown-input-text", { focused: props.dropdownOpen, 'bg-grey-200': _ctx.disabled }]),
      onFocus: _cache[0] || (_cache[0] = () => emit('open')),
      onInput: handleInput,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled
    }, null, 42, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["label", { 'text-primary-blue': props.dropdownOpen, 'bg-grey-200': _ctx.disabled }]),
      style: {"z-index":"1"}
    }, _toDisplayString(_ctx.label), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown-menu show w-100 border-0 px-3 px-md-0", [props.dropdownOpen ? '' : 'd-none']])
    }, [
      _renderSlot(_ctx.$slots, "dropdown")
    ], 2)
  ], 512))
}
}

})